import moment from 'moment';

export default class helper {
    static isCell(element) {
        // Cell should be an input.
        if(element.nodeName !== 'INPUT') return false;
        // Cell should have a parent.
        if(!element.parentElement) return false;
        // Parent should be a table cell.
        if(element.parentElement.nodeName !== 'TD') return false;
        // Cell should have a grandparent.
        if(!element.parentElement.parentElement) return false;
        // Grandparent should be a table row.
        if(element.parentElement.parentElement.nodeName !== 'TR') return false;
        // Grandparent should have an id.
        if(!element.parentElement.parentElement.id) return false;
        // ID should be at least 8 characters.
        return element.parentElement.parentElement.id.length > 8;
    }
    static formatAmount(amount) {
        return parseFloat(Math.round(amount * 100) / 100).toFixed(2);
    }
    static getCurrentPathAsArray() {
        let path        = window.location.pathname;
        return path.substring(1).split('/');
    }
    static getCurrentPageSlug() {
        let pathArray   = this.getCurrentPathAsArray();
        let slug        = '';
        if(pathArray instanceof Array) {
            for(let i = 0; i < pathArray.length; i++) {
                let path = pathArray[i];
                if(i > 0) path = this.capitalizeFirstLetter(path);
                slug += path;
            }
        }
        return slug;
    }
    static getCurrentPageName() {
        switch(this.getCurrentPageSlug()) {
            case 'incomeSingle':
                return 'One-time income';
            case 'incomeMonth':
                return 'Monthly income';
            case 'expensesSingle':
                return 'One-time expenses';
            case 'expensesMonth':
                return 'Monthly expenses';
            default:
        }
    }

    static isTablePageActive() {
        return !!this.getCurrentPageName();
    }

    static getFirstWord(word) {
        if(!word) return;
        let wordArray = word.split(' ');
        return wordArray[0];
    }

    static capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    static getDefaultObject() {
        let pathArray   = this.getCurrentPathAsArray();
        let obj = {
            count: true,
            title: '',
            amount: 0
        };
        if(pathArray[1] === 'single') {
            obj.date = moment().startOf('day').add(1, 'day').format('ggggMMDD');
        } else if(pathArray[1] === 'month') {
            obj.day = 1;
        }
        return obj;
    }

    static isValidEmail(email) {
        let emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        return emailRegex.test(email);
    }
    static isValidAmount(amount) {
        return !isNaN(parseFloat(amount)) && isFinite(amount);
    }
}


// WEBPACK FOOTER //
// ./src/services/helper.js